import React from 'react';

const labels={
    duration:'продолжительность',
    unsuccessful:'провал',
    values:'значения',
    location:'место',
    description:'описание',
    control:'управление',
    type:'тип',
    time:'время',
    sensor:'датчик',
    error:'ошибка',
    health:'здоровье',
    x:'x',
    y:'y',
    days: 'дни ',
    registrations: 'регистрации ',
    downloads: 'загрузки ',
    orders: 'заказы ',
    users: 'активные игроки ',
    sessions: 'игровые сессии ',
    playTime: 'время в игре ',
    sessionsLength: 'среднее время игры ',
    usersSession: 'входы в игру в день ',
    licenses: 'открытые лицензии',
    failureReason : 'причина невозможности покупки',
    id : 'идентификатор',
    receivedEnergy : 'получено энергии',
    remainedEnergy : 'стало эенргии',
    attemptsCount: 'количество попыток',
    attempt : '№ попытки',
    flipped : 'тест пропущен',
    testEvent : 'тип завершения теста',
    occasion : 'событие',
    header : 'команда',
    body : 'сообщение команды',
    answer : 'ответ',
    label : 'название',
    speech : 'описание',
    username: 'ключ',
    condition: 'состояние',
    stacktrace: 'трассировка стека'
};

export default ({object,field})=>{
    let val=object[field];
    if(typeof  val === 'boolean'){
        val = val ? 'true' : 'false'
    }
    if(val===undefined || val===false){
        return null;
    }
    const label=labels[field];
    if(Array.isArray(val)){
        val = "["+val.toString()+"]";
    }
    return <p className='field'><b>{label+': '}</b>{val}</p>;
}